import { createRouter, createWebHashHistory, RouteRecordRaw } from 'vue-router';
import TournamentView from '@/views/Tournaments/TournamentView.vue';
import MainTournament from '@/views/Tournaments/components/Main.vue';
import WatchTournament from '@/views/Tournaments/components/WatchTournament.vue';
import EditTournament from '@/views/Tournaments/components/EditTournament.vue';
import TrendingTournaments from '@/views/Tournaments/components/TrendingTournaments.vue';

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'home',
    component: MainTournament,
  },
  {
    path: '/tournaments',
    name: 'tournament-index',
    component: TournamentView,
    children: [
      {
        path: '',
        name: 'tournament-home',
        component: MainTournament,
      },
      {
        path: 'new',
        name: 'tournament-create',
        component: EditTournament,
      },
      {
        path: 'new/:id',
        name: 'tournament-edit',
        component: EditTournament,
      },
      {
        path: ':id',
        name: 'tournament-view',
        component: WatchTournament,
      },
      {
        path: 'trending',
        name: 'tournament-list',
        component: TrendingTournaments,
      },
    ],
  },
];

const router = createRouter({
  history: createWebHashHistory(process.env.BASE_URL),
  routes,
});

export default router;
